import angular from 'angular';
import utils from 'utils/lsp-utils-service';

import OnEnterController from './components/on-enter/on-enter-controller';
import OnEnterDirective from './components/on-enter/on-enter-directive';

export default angular
  .module('lsp-keyboard', [])
  .controller('onEnterController', OnEnterController)
  .directive('onEnter', utils.createNgFactory(OnEnterDirective));



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-keyboard/lsp-keyboard-module.js